module.exports = __webpack_public_path__ + "img/expostyle_9347_mandarine_pantone2012c.23f534eb.jpg";